import { Group } from '@mantine/core';
import { trackEvent } from '@repo/common/analytics';
import { Button } from '@repo/foundations';
import { lowerCase } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { useAuthUser } from '../../../../api';
import { entityModalStore } from '../../store';

function DocumentFooter() {
	const { user, workspace } = useAuthUser();
	const navigate = useNavigate();

	const handleOnClick = () => {
		trackEvent(`${entityModalStore.type}/create`, {}, user, workspace!);
		entityModalStore.create(navigate);
	};

	return (
		<Group position="right">
			<Button
				onClick={handleOnClick}
				loading={entityModalStore.loading}
				variant="primary"
			>
				Create {lowerCase(entityModalStore.type)}
			</Button>
		</Group>
	);
}

const DocumentFooterObserver = observer(DocumentFooter);
export default DocumentFooterObserver;
